import { convertToDatum } from '../../Util';
import Vue from 'vue';
import { DateDatum } from '.';
import { IndexDatum } from '.';

const Observer = (new Vue()).$data.__ob__.constructor;


/**
 * 
 */
export class TimeSeries extends Array {
  /**
   * Initialize a TimeSeries from an input Array
   * 
   * @param {Array} input Array of Datum or Datum-compatible value pairs
   */
  constructor(input) {
    super();
    this.createObserver(); // Hack to avoid Vue destroying the class
    
    // Handle empty initialization
    let inputArray = input ?? [];
    this.push(...inputArray);
  }

  createObserver() {
    // Split into a separate function for easy unit test mocking
    this.__ob__ = new Observer({});
  }


  /**
   * Push Datum-compatible elements into the TimeSeries
   * 
   * @param  {...any} inputArray List of items to add to the TimeSeries
   */
  push(...inputArray) {
    let firstType;

    for (let i of inputArray) {
      let datum = convertToDatum(i);

      if (!firstType) {
        firstType = (this[0] ?? datum).constructor;
      }

      if (datum.constructor === firstType
          && (datum instanceof DateDatum || datum instanceof IndexDatum)) {
        super.push(datum);
      } else {
        throw Error('Datum type misaligned with earlier elements');
      }
    }
  }


  /** Return an array of all the TimeSeries dates */
  getIndices() { return Array.from(this).map(v => v.index); }

  /** Return an array of all the TimeSeries values */
  getValues() { return Array.from(this).map(v => v.value);  }
  
  /** Return an array with [index, value] pair items */
  getPairs() { return Array.from(this).map(v => [v.index, v.value]); }
}